<template>
<div class="container">
  <div class="order-wrapper">
    <h5 class="header">班主任详情</h5>
    <div class="order-body">
      <div class="teacher-panle" v-if="masterInfo">
        <div class="teacher-box">
          <div class="teacher-qr">
            <img class="img" :src="masterInfo.masterWxQeCode"/>
          </div>
          <div class="teacher-info">
            <div class="teacher">
              <img class="touxiang" :src="masterInfo.masterHeadImage"/>
              <span class="teacher-name">{{masterInfo.masterPetName}}</span>
            </div>
            <div class="wechat-number">{{masterInfo.masterWxCode}}</div>
          </div>
        </div>
        <div class="copy-btn"
          v-clipboard:copy="masterInfo.masterWxCode"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError">
          点击复制班主任微信号
        </div>
      </div>
      <div class="no-data" v-else>
        <p v-if="isFail" class="loading-text">请联系您的英语班主任获取数学班主任的联系方式。</p>
        <van-loading v-else type="spinner" color="#333" size="18px" vertical>
          <p class="loading-text">正在获取班主任信息...</p>
        </van-loading>
      </div>
      <div class="thinking-class-detail top-24">课程须知</div>
      <div class="thinking-class-mulu-parent">
        <div class="title">上课形式</div>
        <div class="content">每周固定时间上课，固定老师，固定班主任。由于是班课，错过课程仍会扣除课时，可查看课程回放补课。</div>
        <div class="title">社群服务</div>
        <div class="content">请务必添加数学班主任微信，开课前数学班主任将邀请您进入学习群，群内将不定时分享学习资料。</div>
        <div class="title">关于发货</div>
        <div class="content">教辅材料购买后按顺序发货，7个工作日内包邮寄出，家长可在App“我-物流”中查看进度。</div>
        <div class="title">问题咨询</div>
        <div class="content">有任何疑问，可与数学班主任微信联系。</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { getMasterInfo } from '@/api/masterDetail'

export default {
  data () {
    return {
      isFail: false, // 是否10s后还是失败
      masterInfo: null,
      timer: null,
      count: 1
    }
  },
  mounted () {
    let {
      payOrderId
    } = this.$route.query
    this.getMasterData(payOrderId)
  },
  components: {},
  methods: {
    async getMasterData (data) {
      try {
        let res = await getMasterInfo(data)
        this.timer && clearTimeout(this.timer)
        let masterData = res.data
        if (masterData) {
          this.timer = null
          this.masterInfo = res.data
          return true
        }
        // 循环调用 连续调用 10 次
        if (this.count <= 10) {
          this.count++
          this.timer = setTimeout(this.getMasterData, 1000, data)
          return true
        } else {
          this.isFail = true // 获取失败
          return false
        }
      } catch (e) {
        this.isFail = true // 获取失败
      }
    },
    onCopy () {
      this.$toast('复制成功')
    },
    onError () {
      this.$toast('复制失败,您的手机不支持复制功能')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-wrapper {
  width: 100%;
  min-height: inherit;
  background:rgba(248,248,248,1);
  .header {
    width: 100%;
    height: 88px;
    line-height: 88px;
    font-size: 36px;
    color: #333;
    text-align: center;
    font-weight: bold;
    background: #fff;
  }
  .order-body {
    position: relative;
    width: 100%;
    height: auto;
    .no-data {
      width: 686px;
      height: 400px;
      margin: 32px auto;
      background-color: #fff;
      @include flexBox($justify: center);
      .loading-text {
        margin-top: 10px;
      }
    }
    .teacher-panle {
      position: relative;
      width: 686px;
      height: 400px;
      margin: 32px auto;
      background-color: #fff;
      border-radius: 16px;
      padding: 64px 48px 48px 48px;
      .teacher-box {
        display: flex;
      }
      .teacher-qr {
        // width: 160px;
        flex: 0 0 160px;
        height: 160px;
        border-radius: 16px;
        .img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .teacher-info {
        position: relative;
        width: 532px;
        height: 320px;
        margin-left: 48px;
        flex: 1;
        .teacher {
          position: relative;
          font-size: 0px;
          height: 80px;
          @include flexBox();
          .touxiang {
            display: block;
            width: 80px;
            height: 80px;
            border-radius: 50%;
          }
          .teacher-name {
            width: 320px;
            color: #333;
            font-size: 32px;
            text-align: left;
            line-height: 80px;
            padding-left: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .wechat-number {
          text-align: left;
          line-height: 44px;
          width: 380px;
          font-size: 32px;
          color: #333;
          margin-top: 48px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .copy-btn {
        position: absolute;
        clear: both;
        bottom: 48px;
        width: 340px;
        height: 80px;
        margin-top: 48px;
        background-color: #00d1a9;
        border-radius: 40px;
        text-align: center;
        font-size: 28px;
        color: #fff;
        padding-top: 26px;
        left: 50%;
        margin-left: -170px;
      }
    }
    .thinking-class-detail {
      width: 686px;
      margin: 0 auto;
      color: #333;
      font-size: 36px;
      font-weight: bold;
      text-align: left;
      padding: 40px 0 24px;
      &.top-24 {
        margin-top: 40px;
      }
      &.padding-16 {
        padding-top: 16px;
      }
    }
    .thinking-class-mulu-parent {
      position: relative;
      width: 686px;
      height: auto;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 16px;
      padding: 0px 32px 40px 32px;
      .title {
        position: relative;
        width: 100%;
        color: #333;
        font-size: 28px;
        font-weight: bold;
        text-align: left;
        padding-top: 40px;
        padding-bottom: 16px;
      }
      .content {
        position: relative;
        width: 100%;
        color: #999;
        font-size: 24px;
        line-height: 40px;
        text-align: left;
      }
    }
  }
}

</style>
